import { createFeatureSelector, createSelector } from '@ngrx/store';
import { whitelistFeature, WhiteListUrlState } from './whitelist-URL.reducer';

export const selectURL = createFeatureSelector<WhiteListUrlState>(
  whitelistFeature
);
export const selectURLResults = createSelector(
  selectURL,
  (state: WhiteListUrlState) => (state ? state.results : null)
);
export const selectSuccessMessage = createSelector(
  selectURL,
  (state: WhiteListUrlState) => (state ? state.successMessage : null)
);
export const selectWhiteListPermissions = createSelector(
  selectURL,
  (state: WhiteListUrlState) => (state ? state.whiteListUrlPermissions : null)
);
export const selectWhiteListMetadata = createSelector(
    selectURL,
    (state: WhiteListUrlState) => (state ? state.whiteListUrlMetadata : null)
);
